import { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";

import { FlocknoteAppState } from "Flocknote/state.js";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";
import { AnimatePresence, motion } from "framer-motion";

import { ButtonIcon } from "UI/FnrButton3";
import FnrPreviewBar, {
  ActionButton,
  ActionButtons,
  MultiButtonsHolder,
} from "UI/FnrPreviewBar";
import { inOutMotion } from "UI/motionStyles";

import useScreenWidth from "Utilities/Hooks/useScreenWidth";

import { useShouldShowSignupBoard } from "./utils/useShouldShowSignupBoard";

export default function SignupSheetFooter() {
  const [fnState, fnDispatch] = useContext(FlocknoteAppState);
  const [state] = useSignups();
  const screenWidth = useScreenWidth();
  const composerMinimized = fnState?.composer?.minimized;
  const signupListID = state.currentSignupList?.ID;
  const signupListStatusID = state.currentSignupList?.signupListStatusID;
  const { signupTab } = useParams();
  const isPublic = Boolean(state.currentSignupList?.options?.public);

  const addToEmailNote = () => {
    localStorage.setItem(
      "signupObj",
      JSON.stringify({ ID: signupListID, timestamp: Date.now() })
    );
    window.fnReactBus.openEmailComposer();
    fnDispatch({ type: "Composer Maximized" });
  };

  const addToTextNote = () => {
    // 		setLoading(true);
    localStorage.setItem(
      "signupObj",
      JSON.stringify({ ID: signupListID, timestamp: Date.now() })
    );
    window.fnReactBus.openTextComposer();
    fnDispatch({ type: "Composer Maximized" });
  };

  const url = `${window.location.origin}/signup/${signupListID}`;

  const { forceToAddItem, hideItemsList } = useNewSignupCreationFlow();
  const shouldShowSignupBoard = useShouldShowSignupBoard();

  const hideFooter = signupTab === "respondents" && shouldShowSignupBoard;

  const marginLeft = useMemo(() => {
    if (screenWidth < 1480) return "0px";
    return "300px";
  }, [screenWidth]);

  return (
    <AnimatePresence>
      {!hideFooter && (
        <motion.div {...inOutMotion}>
          <FnrPreviewBar
            style={{ marginLeft, transition: "margin-left 300ms" }}
            url={url}
            title="Here&#39;s the link to your Signup "
            shouldHideInitial={forceToAddItem}
            shouldHideAnimation={forceToAddItem || hideItemsList}
            showActionButtons={signupListStatusID === 1}
            isPublic={isPublic}
            composerMinimized={composerMinimized}
            renderActionButtons={() => (
              <ActionButtons>
                {composerMinimized ? (
                  <ActionButton
                    clickHandler={addToEmailNote}
                    text="Add to my Email"
                    icon={<ButtonIcon fas fa-envelope />}
                    color="green"
                    data-cy="addSignupToEmail"
                  />
                ) : (
                  <MultiButtonsHolder>
                    <ActionButton
                      clickHandler={addToEmailNote}
                      text="Email"
                      icon={<ButtonIcon fas fa-envelope />}
                      color="blue"
                      borderRadius="8px 0 0 8px"
                      innerBorderRadius="6px 0 0 6px"
                      data-cy="addSignupToEmail"
                    />

                    <ActionButton
                      clickHandler={addToTextNote}
                      text="Text"
                      icon={<ButtonIcon far fa-mobile />}
                      style={{ marginLeft: -2 }}
                      color="blue"
                      borderRadius="0 8px 8px 0"
                      innerBorderRadius="0 6px 6px 0"
                      data-cy="addSignupToText"
                    />
                  </MultiButtonsHolder>
                )}
              </ActionButtons>
            )}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
